import React from "react";
import DateTimeFormatter from "components/common/DateTimeFormatter";
import SimpleTooltip from "components/common/SimpleTooltip";
import { FiClock } from "react-icons/fi";

class DateTimeTooltip extends React.Component {
  render() {
    const { data, format } = this.props;
    return (
      <SimpleTooltip
        tooltipText={data.map(({ label, value }) => (
          <div key={label} className="mb-1">
            <span className="font-semibold">{label}:</span>{" "}
            <DateTimeFormatter datetime={value} format={format} />
          </div>
        ))}
      >
        <div className="text-lg text-gray-600 hover:text-gray-800">
          <FiClock></FiClock>
        </div>
      </SimpleTooltip>
    );
  }
}

export default DateTimeTooltip;
